import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import cnJson from './cn.json'
const cn = {
	...cnJson,
	...zhLocale
}
export default cn
